import { render, staticRenderFns } from "./page-liberacoes.vue?vue&type=template&id=5b8d1ab6"
import script from "./page-liberacoes.vue?vue&type=script&lang=js"
export * from "./page-liberacoes.vue?vue&type=script&lang=js"
import style0 from "./page-liberacoes.vue?vue&type=style&index=0&id=5b8d1ab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports